// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import vSelect from 'vue-select';
// import VueMeta from 'vue-meta';
// import VueGtag from 'vue-gtag';
import VueGtm from 'vue-gtm';

// Import only the Bootstrap Vue components that are actually used
import {
  // Layout
  BContainer,
  BCol,
  BFormRow,
  // Navigation
  BNavbar,
  BNavbarBrand,
  BNavbarToggle,
  BNavbarNav,
  BNav,
  BNavItem,
  BCollapse,
  // Buttons
  BButton,
  BButtonGroup,
  // Cards
  BCard,
  // Forms
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormTextarea,
  BFormRadioGroup,
  // Display
  BSpinner,
  BAlert,
  BBadge,
  BAvatar,
  BProgress,
  BLink,
  // Carousel
  BCarousel,
  BCarouselSlide,
  // Modal
  BModal,
  // Directives
  VBToggle,
} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';
import Loader from '@/components/widgets/Loader';
import VueMasonry from 'vue-masonry-css';
import 'vue-select/dist/vue-select.css';
import LoadScript from 'vue-plugin-load-script';
// import VueAnalytics from 'vue-analytics';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faExternalLinkAlt, faUser, faChevronLeft, faCheck, faCreditCard, faCaretDown, faFileInvoiceDollar, faEllipsisV, faChevronRight, faPlus, faHome, faTruck, faTshirt, faKey, faFileCsv, faShoppingCart, faThumbsUp, faThumbsDown, faUpload, faFile, faTimes, faQuestion, faDollarSign, faMobile, faEnvelope, faThumbtack, faBars, faSignOutAlt, faSyncAlt, faHeart, faChevronUp, faChevronDown, faEllipsisH, faTh, faThLarge, faFingerprint, faRedo, faCaretLeft, faCircle, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faCcMastercard, faCcVisa, faFacebook, faInstagram, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.component('v-select', vSelect);

library.add(faCaretLeft, faFingerprint, faExternalLinkAlt, faTh, faThLarge, faCcVisa, faCcMastercard, faHeart, faSyncAlt, faBars, faSignOutAlt, faMobile, faEnvelope, faThumbtack, faDollarSign, faUser, faInstagram, faTwitter, faFacebook, faChevronLeft, faChevronUp, faChevronDown, faCheck, faCreditCard, faCaretDown, faFileInvoiceDollar, faEllipsisV, faEllipsisH, faChevronRight, faPlus, faHome, faTruck, faTshirt, faKey, faFileCsv, faShoppingCart, faThumbsUp, faThumbsDown, faArrowRight, faUpload, faCheck, faFile, faTimes, faQuestion, faRedo, faCircle);
Vue.component('font-awesome-icon', FontAwesomeIcon);

dom.watch();
Vue.config.productionTip = false;

// Register only the Bootstrap Vue components we actually use
Vue.component('BContainer', BContainer);
Vue.component('BCol', BCol);
Vue.component('BFormRow', BFormRow);
Vue.component('BNavbar', BNavbar);
Vue.component('BNavbarBrand', BNavbarBrand);
Vue.component('BNavbarToggle', BNavbarToggle);
Vue.component('BNavbarNav', BNavbarNav);
Vue.component('BNav', BNav);
Vue.component('BNavItem', BNavItem);
Vue.component('BCollapse', BCollapse);
Vue.component('BButton', BButton);
Vue.component('BButtonGroup', BButtonGroup);
Vue.component('BCard', BCard);
Vue.component('BForm', BForm);
Vue.component('BFormGroup', BFormGroup);
Vue.component('BFormInput', BFormInput);
Vue.component('BFormCheckbox', BFormCheckbox);
Vue.component('BFormTextarea', BFormTextarea);
Vue.component('BFormRadioGroup', BFormRadioGroup);
Vue.component('BSpinner', BSpinner);
Vue.component('BAlert', BAlert);
Vue.component('BBadge', BBadge);
Vue.component('BAvatar', BAvatar);
Vue.component('BProgress', BProgress);
Vue.component('BLink', BLink);
Vue.component('BCarousel', BCarousel);
Vue.component('BCarouselSlide', BCarouselSlide);
Vue.component('BModal', BModal);

// Register the v-b-toggle directive
Vue.directive('b-toggle', VBToggle);
Vue.use(Loader);
Vue.use(VueMasonry);
Vue.use(LoadScript);
// Vue.use(VueMeta);

// Vue.use(VueAnalytics, {
//   id: 'UA-221726265-1',
//   router,
// });
Vue.use(VueGtm, {
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router, // If router, you can exclude some routes name (case insensitive) (optional)
});

// Vue.use(VueGtag, {
//   config: { id: 'GTM-NHJGJ49P' },
// });
// Vue.use(VueGtm, {
//   id: 'GTM-NHJGJ49P', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
//   // queryParams: {
//   //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
//   //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
//   //   gtm_preview: 'env-4',
//   //   gtm_cookies_win: 'x',
//   // },
//   defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
//   compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
//   // nonce: '2726c7f26c', // Will add `nonce` to the script tag
//   enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
//   debug: true, // Whether or not display console logs debugs (optional)
//   loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
//   vueRouter: router, // Pass the router instance to automatically sync with router (optional)
//   // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
//   trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js